import type { NormalizedResource } from '@/lib/cms-resources'
import TOOLS_DATA from '@/data/tools.json'

export const TOOL_LOGO_BY_SLUG = new Map<string, { logo: string; name: string }>()
for (const row of TOOLS_DATA as { id: string; name: string; logo: string }[]) {
  TOOL_LOGO_BY_SLUG.set(row.id, { logo: row.logo, name: row.name })
}

const CARD_LOGO_COLORS = [
  'bg-blue-100 text-blue-700',
  'bg-violet-100 text-violet-700',
  'bg-emerald-100 text-emerald-700',
  'bg-amber-100 text-amber-700',
  'bg-rose-100 text-rose-700',
]

export function cardLogoFallbackClass(label: string) {
  return CARD_LOGO_COLORS[label.charCodeAt(0) % CARD_LOGO_COLORS.length]
}

/** Featured image, or tool logo when the resource slug matches a known tool. */
export function featuredOrToolImage(item: NormalizedResource): {
  src: string | null
  fallbackLabel: string
} {
  const tool = TOOL_LOGO_BY_SLUG.get(String(item.slug))
  const src = item.featured_image_url || tool?.logo || null
  const fallbackLabel = tool?.name || item.title
  return { src, fallbackLabel }
}

/** Resolves tool ids (from data/tools.json / Posts.worksWithTools) to logo + name, dropping unknown ids. */
export function resolveWorksWithTools(
  toolIds: string[] | null | undefined,
): { id: string; name: string; logo: string }[] {
  if (!Array.isArray(toolIds) || toolIds.length === 0) return []
  const out: { id: string; name: string; logo: string }[] = []
  for (const id of toolIds) {
    const tool = TOOL_LOGO_BY_SLUG.get(id)
    if (tool) out.push({ id, name: tool.name, logo: tool.logo })
  }
  return out
}
